var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kontainer",staticStyle:{"height":"600px"}},[(_vm.loading)?_c('b-spinner',{staticStyle:{"position":"absolute","left":"28px"},attrs:{"variant":"primary","label":"Spinning"}}):_vm._e(),_c('div',{staticStyle:{"border":"1px solid black","height":"600px","width":"100%"},attrs:{"id":"modell"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }